import { render, staticRenderFns } from "./ReviewFrame.vue?vue&type=template&id=76429218"
import script from "./ReviewFrame.vue?vue&type=script&lang=js"
export * from "./ReviewFrame.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports